import type { MediaCollection } from '#components/Media/ArdPlayer/ArdPlayerInternal.tsx';
import { formatTimestamp } from '#utils/time/formatTimestamp';

import FaviconSVG from '../../../../icons/site/favicon.svg';
import { ArdPlayer } from '../Media/ArdPlayer';

import styles from './NewsPlayer.module.scss';
import type { ShortnewsOverviewQuery } from './__generated__/Shortnews.generated';

type Props = { className?: string; audio: ShortnewsOverviewQuery['newsAudio'] };

export function NewsPlayer({ className = '', audio }: Props) {
	if (!audio) {
		return null;
	}

	const { title, duration, updateDate, url, description } = audio;

	const mediaCollection: MediaCollection = {
		meta: {
			title: title,
			// no need to supply the current time as absolute formatting does not need the current time.
			subHeading: updateDate ? formatTimestamp(updateDate, new Date(), { isAbsolute: true }) : undefined,
			synopsis: description ?? undefined,
			clipSourceName: 'BR24',
			durationSeconds: duration ?? undefined,
			images: [
				{
					kind: 'audio',
					url: FaviconSVG.src,
					imageSourceName: 'BR24',
					mimeType: 'image/svg',
				},
			],
		},
		streams: [
			{
				kind: 'main',
				isAudioOnly: true,
				media: [
					{
						url: url,
						mimeType: 'audio/mp3',
						audios: [
							{
								kind: 'standard',
								languageCode: 'de',
							},
						],
					},
				],
			},
		],
	};

	return (
		<section className={`${styles.wrapper} ${className}`}>
			<ArdPlayer mediaCollection={mediaCollection} playerStyle="small-audio" />
		</section>
	);
}
